import { colors, intl } from '@beelday/common'
import styled from '@emotion/styled'
import groupAtAFlipChart from 'features/simple-grouping/images/group-at-a-flip-chart.png'
import groupAtATable from 'features/simple-grouping/images/group-at-a-table.png'
import { LobbyStatus } from 'room/lobby/presentation/lobby-status'
import {
	Card,
	CardLabel,
	CardText,
	CardTitle,
	Eyebrow,
	Screen,
} from './primitives'

const TaskCard = styled(Card)`
	margin-bottom: 12px;
	padding: 0;
	overflow: hidden;
`

/** The stage's two pictures of people at work, side by side over the task. */
const Banner = styled.div`
	display: flex;
	align-items: flex-end;
	justify-content: center;
	gap: 4px;
	height: 170px;
	padding: 14px 12px 0;
	background: linear-gradient(${colors.indigoBlue05}, ${colors.white});

	img {
		height: 150px;
		width: auto;
		max-width: 50%;
		object-fit: contain;
		user-select: none;
	}
`

const TaskBody = styled.div`
	padding: 14px 20px 20px;
`

type Props = {
	name?: string
	description?: string
}

/**
 * Group work: the task, so each table can re-read it without turning to the
 * projector, under the stage's pictures of people at work, and the stage's
 * line under it: the screen changes by itself. No timer and no roster -
 * `SimpleGrouping` carries neither a duration nor who is in which group. A
 * trainer may leave the task blank; the card then says it will be explained
 * in the room, rather than leaving the screen all but empty.
 */
export const GroupWorkView = ({ name, description }: Props): JSX.Element => (
	<Screen data-testid="in_person.mobile.group_work">
		<Eyebrow>
			<intl.Translate>features.simple-grouping.title</intl.Translate>
		</Eyebrow>
		<TaskCard>
			<Banner aria-hidden="true">
				<img src={groupAtATable} alt="" draggable={false} />
				<img src={groupAtAFlipChart} alt="" draggable={false} />
			</Banner>
			<TaskBody>
				<CardLabel>
					<intl.Translate>in_person.mobile.group_work.task</intl.Translate>
				</CardLabel>
				{name ? <CardTitle>{name}</CardTitle> : null}
				{description ? <CardText>{description}</CardText> : null}
				{name || description ? null : (
					<CardText>
						<intl.Translate>in_person.mobile.group_work.no_task</intl.Translate>
					</CardText>
				)}
			</TaskBody>
		</TaskCard>
		<LobbyStatus size="phone">
			<intl.Translate>features.simple-grouping.status</intl.Translate>
		</LobbyStatus>
	</Screen>
)

export default GroupWorkView
